import { Languages } from '../types';

export const translationImportByLanguage: Record<
  Languages,
  () => Promise<{
    default: Record<string, string>;
  }>
> = {
  [Languages.en]: () => import('@/assets/i18n/en.json'),
  [Languages.ru]: () => import('@/assets/i18n/ru.json'),
};
